// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
// Model
import { StaticMapConfig, StaticMapRequest, StaticMarker } from '../models/map-service.model';
// Other
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' }) // Review to put a module instead of root
export class MapService {

	// Needs to come from the Config File
	private mapKey = '';
	private publicAPI = 'https://maps.googleapis.com/maps/api';

	private defaultConfig: StaticMapConfig = new StaticMapConfig();

	constructor(
		private httpClient: HttpClient,
	) {
	}

	/**
	 * Set the map key
	 *
	 * @param key
	 */
	public setMapKey(key: string): void {
		this.mapKey = key;
	}

	/**
	 * Set the Google Map API
	 * This methods needs to be called at the beginning to ensure the API is fully loaded before to use
	 */
	public isGoogleMapAPISet(): Observable<any> {
		// Verify the Google Lib is already on the Dom
		const googleLib = window['google'];
		if (googleLib) {
			return of({});
		}
		// Note: HttpClientJsonpModule needs to be installed at the App Module for the JSONP to Work
		return this.httpClient.jsonp(
			`${this.publicAPI}/js?key=${this.mapKey}`,
			'callback'
		).pipe(
			map(() => true),
			catchError(() => of(false))
		);
	}

	/**
	 * Get a Blob From a Static Image
	 */
	public getStaticImageAsBlob(request: StaticMapRequest, desktopServiceUrl:string='', config: StaticMapConfig = null): Observable<Blob> {
		// Use Default Configuration
		const mapConfig: StaticMapConfig = (config !== null) ? { ...this.defaultConfig, ...config } : this.defaultConfig;

		// Prepare Request
		let params = null;
		params = new HttpParams()
			.set('center', `${(request.address) ? request.address : request.location.lat},${request.location.lng}`)
			// .set('zoom', mapConfig.zoom) I found that with the zoom the calculation because tricky
			.set('size', mapConfig.size)
			.set('scale', mapConfig.scale)
			.set('maptype', mapConfig.type);

		// Main Marker can be added only if it is not an Address
		if (!request.address) {
			params = params.append('markers', `icon:${mapConfig.homeIcon}|${request.location.lat},${request.location.lng}`);
		}
		// Add Markers
		request.markers.forEach((marker: StaticMarker) => {
			let markerConfig = (marker.icon) ? `icon:${marker.icon}` : `color:${marker.color}`;
			markerConfig += `|${marker.location.lat},${marker.location.lng}`;
			params = params.append('markers', markerConfig);
		});
		const queryString = `${params.toString()}&key=${this.mapKey}`;
		const url = `${desktopServiceUrl}utils/staticmap?${queryString}`;
		return this.httpClient.get(url, { responseType: 'blob' });
	}

}
